<template>
  <div class="container">
    <Breadcrumb :list="breadList" />
    <div class="top" v-if="detail">
      <h1 v-html="detail.name"></h1>
      <div class="flex">
        <div class="top-left">
          <img :src="detail.pictureUrl" alt="" />
        </div>
        <div class="top-right">
          <div class="list">
            <ul>
              <li>
                <img src="@/assets/images/icon-c-d-1.png" alt="" />
                <div>课时</div>
                <div>{{ detail.period }}学时</div>
              </li>
              <li>
                <img src="@/assets/images/icon-c-d-2.png" alt="" />
                <div>学习时间</div>
                <div>{{ detail | resetTime }}</div>
              </li>
              <li>
                <img src="@/assets/images/icon-c-d-3.png" alt="" />
                <div>包含课程</div>
                <div>{{ `${detail.courseNumber || 0}门课程` }}</div>
                <div>{{ `${detail.trainNumber || 0}门实训` }}</div>
              </li>
              <li>
                <img src="@/assets/images/icon-c-d-4.png" alt="" />
                <div>地点</div>
                <div>{{ detail.address }}</div>
              </li>
              <li>
                <img src="@/assets/images/icon-c-d-5.png" alt="" />
                <div>培训人数</div>
                <div>{{ detail.studentSum || 0 }}人</div>
              </li>
              <li>
                <img src="@/assets/images/icon-c-d-6.png" alt="" />
                <div>联系方式</div>
                <div>{{ detail.consultPhone }}</div>
              </li>
            </ul>
          </div>
          <div class="right-row">
            <span>主办方：</span>
            {{ detail.sponsor }}
          </div>
          <div class="right-row" v-if="detail.contractor">
            <span>承办方：</span>
            {{ detail.contractor }}
          </div>
          <div class="right-row">
            <span>培训对象：</span>
            <el-tooltip effect="dark" :open-delay="200" placement="top">
              <div slot="content" class="tooltip-text">{{ detail.trainObject }}</div>
              <span>
                <span class="not">
                  {{ detail.trainObject }}
                </span>
                <span v-if="detail.trainObject && detail.trainObject.length >= 36" class="not tips-inidex">【查看更多】</span>
              </span>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-b" v-if="detail.introduction">
        <span><i></i>培训任务和目标</span>
        {{ detail.introduction }}
      </div>
    </div>
    <div class="center" v-if="detail">
      <div class="center-p center-one">
        <div class="left">
          <img src="@/assets/images/icon-c-d-7.png" alt="" />
          <div>培训班助手</div>
        </div>
        <div v-if="status.stauts" class="right">
          <template v-if="status.stauts === 1">
            <div class="title">
              {{ detail.openStartTime.split(' ')[0] }} 至
              {{ detail.openEndTime.split(' ')[0] }}
            </div>
            <div class="day">
              <span>{{ status.value }}</span>
              <span>天</span>
            </div>
            <div class="tips">距离报到还有</div>
          </template>
          <template v-else-if="status.stauts === 2">
            <div class="title">
              {{ detail.openStartTime.split(' ')[0] }} 至
              {{ detail.openEndTime.split(' ')[0] }}
            </div>
            <div class="day">
              <span>{{ status.value }}</span>
              <span>天</span>
            </div>
            <div class="tips">距离开班还有</div>
          </template>
          <template v-else-if="status.stauts === 3">
            <div class="title">
              {{ detail.openStartTime.split(' ')[0] }} 至
              {{ detail.openEndTime.split(' ')[0] }}
            </div>
            <div class="day">
              <span>{{ status.value }}</span>
              <span>天</span>
            </div>
            <div class="tips">距离培训班结束还有</div>
          </template>
          <template v-else-if="status.stauts === 4">
            <img src="@/assets/images/icon-c-d-12.png" class="tips-icon" />
            <div class="tips default">培训班已结束</div>
          </template>
        </div>
      </div>
      <div class="center-p center-two">
        <div class="left">
          <img src="@/assets/images/icon-c-d-8.png" alt="" />
          <div>收获</div>
        </div>
        <div class="right">
          <div class="title">本次培训班可获得</div>
          <div class="get-data">
            <div class="get-data-left">
              <img src="@/assets/images/icon-c-d-9.png" alt="" />
              <div>
                {{ detail.graduationId ? '已配置证书' : '暂未配置证书' }}
              </div>
            </div>
            <div class="get-data-right">
              <img src="@/assets/images/icon-c-d-10.png" alt="" />
              <div>{{ detail.period }}学时</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom" v-if="detail">
      <div class="b-header">
        <img src="@/assets/images/icon-c-d-11.png" alt="" />
        <span>课程安排</span>
      </div>

      <div class="b-date">
        <!-- {{dateList}} -->
        <!-- <div v-for="(item, i) in dateList" :key="i">

        </div> -->
        <div class="b-date-right-box">
          <div class="b-date-right" v-for="(item, i) in dateList" :key="i">
            <div
              class="b-date-left"
              v-if="i === 0 || (i > 0 && item.month !== dateList[i - 1].month)"
            >
              <ul>
                <li>
                  <div>{{ item.month }}</div>
                  <div>{{ item.year }}</div>
                </li>
              </ul>
            </div>
            <ul @click="goDetail(item, i)">
              <li :class="{ active: selectIndex == i }">
                <div>{{ item.week }}</div>
                <div>{{ item.day }}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="b-time" ref='bTimeBox'>
        <!-- {{activities}} -->
        <el-timeline>
          <el-timeline-item
            v-for="(item, index) in activities"
            :key="index"
            type="primary"
            color="#D00D0D"
            placement="top"
            :id='item.date'
          >
            <div class="date" >
              <div>{{ item.date }}</div>
              <div>{{ item.week }}</div>
            </div>
            <div style="margin-top:-12px">
              <div class="timestamp">
                {{ item.timestamp }}
                <span v-if="item.scheduleType === '1'">【课程】</span>
                <span v-if="item.scheduleType === '2'">【实训】</span>
                <span v-if="item.scheduleType === '3'">【考察】</span>
                <span v-if="item.scheduleType === '4'">【开班典礼】</span>
                <span v-if="item.scheduleType === '5'">【结业典礼】</span>
                <span v-if="item.scheduleType === '6'">【用餐】</span>
              </div>
              <div class="b-time-title">
                {{ item.title }}
              </div>
              <div class="b-time-des">主讲人：{{ item.speaker }}</div>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb.vue'
import { getClassDescById, getClassDescEsById } from '@/api/face'
import dayjs from 'dayjs'
const isBetween = require('dayjs/plugin/isBetween')
dayjs.extend(isBetween)

export default {
  components: { Breadcrumb },
  data() {
    return {
      breadList: [
        {
          label: '面授培训',
          path: '/faceList'
        },
        {
          label: '面授培训详情',
          path: '/classDetail'
        }
      ],
      detail: null,
      activities: [],
      dateList: [],
      selectIndex: 0
    }
  },
  computed: {
    status() {
      if (this.detail) {
        // 报名时间
        const f1 = dayjs().isBefore(this.detail.signEndTime) || dayjs().isSame(this.detail.signEndTime)
        // 报道时间
        const f2 = dayjs().isBetween(this.detail.reportStartTime, this.detail.reportEndTime, null, '[]')
        // 开班时间
        const f3 = dayjs().isBetween(this.detail.openStartTime, this.detail.openEndTime, null, '[]')
        switch (true) {
          case f1: // 报名时间内
            return {
              stauts: 1,
              value: dayjs(this.detail.reportStartTime).diff(dayjs(), 'day') + 1
            }
          case f2: // 报到时间内
            return {
              stauts: 2,
              value: dayjs(this.detail.openStartTime).diff(dayjs(), 'day') + 1
            }
          case f3: // 开班时间内
            return {
              stauts: 3,
              value: dayjs(this.detail.openEndTime).diff(dayjs(), 'day') + 1
            }
          case dayjs().isAfter(this.detail.openEndTime): // 结束
            return {
              stauts: 4
            }
          default:
            break
        }
      }
      return {}
    }
  },
  filters: {
    resetTime(detail) {
      if (detail) {
        const start =
          detail.openStartTime.split(' ')[0].split('-')[1] +
          '-' +
          detail.openStartTime.split(' ')[0].split('-')[2]
        const end =
          detail.openEndTime.split(' ')[0].split('-')[1] +
          '-' +
          detail.openEndTime.split(' ')[0].split('-')[2]
        return start + ' 至 ' + end
      } else {
        return ''
      }
    },
    endTime(time) {
      if (time) {
        const tamp = new Date(time).getTime() - new Date().getTime()
        if (tamp > 0) {
          return Math.floor(tamp / 1000 / 60 / 60 / 24)
        } else {
          return 0
        }
      } else {
        return 0
      }
    }
  },
  created() {
    this.getClassDescById()
  },
  methods: {
    async getClassDescById() {
      if (this.$route.query.name) {
        const res = await getClassDescEsById({ id: this.$route.query.id, name: this.$route.query.name })
        this.detail = res.data.content[0]
      } else {
        const res = await getClassDescById({ id: this.$route.query.id })
        this.detail = res.data
      }
      const activities = []
      const dateList = []
      const weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
      const months = [
        '一月',
        '二月',
        '三月',
        '四月',
        '五月',
        '六月',
        '七月',
        '八月',
        '九月',
        '十月',
        '十一月',
        '十二月'
      ]
      this.detail.schedules.forEach((item) => {
        const date = item.date.split(' ')[0]
        item.week = weeks[new Date(item.date).getDay()]
        item.date = item.date.split(' ')[0].slice(5, 10)
        const one = activities.find((col) => col.date === item.date)
        if (item.startTime) {
          item.timestamp = `${item.startTime.slice(0, 5)}~${item.endTime.slice(0, 5)}`
        }
        if (one) {
          item.date = ''
          item.week = ''
        } else {
          dateList.push({
            date,
            year: date.slice(0, 4),
            month: months[date.slice(5, 7) - 1],
            day: date.slice(8, 10),
            week: item.week
          })
        }
        activities.push(item)
      })
      this.activities = activities
      this.dateList = dateList
    },
    goDetail(item, i) {
      this.selectIndex = i
      const aa = item.date.slice(5, item.length)
      const targetbox = document.getElementById(aa)
      console.log(targetbox.offsetTop)
      // this.$refs.bTimeBox.scrollTop = targetbox.offsetTop + 30
      this.$refs.bTimeBox.scrollTo({
        top: targetbox.offsetTop + 30,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style lang='scss'>
.container {
  width: 1300px;
  margin: auto;
  margin-top: 30px;
  .top {
    background: #fff;
    padding: 43px 50px 30px;
    h1 {
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #0853b6;
      text-align: center;
      margin-bottom: 35px;
    }
    .flex {
      display: flex;
    }
    .top-left {
      width: 392px;
      height: 214px;
      margin-right: 30px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .top-right {
      flex: 1;
      .list {
        background: #eff4ff;
        padding: 16px 0 14px 0;
        margin-bottom: 22px;
        ul {
          display: flex;
          li {
            flex: 1;
            text-align: center;
            border-right: 1px solid rgba(8, 83, 182, 0.18);
            &:last-child {
              border: 0;
            }
            img {
              width: 28px;
            }
            div {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              line-height: 20px;
              // margin: 7px 0 12px;
            }
            div:nth-child(n + 3) {
              font-weight: bold;
            }
          }
        }
      }
      .right-row {
        width: 665px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        color: #333333;
        line-height: 25px;
        > span:not(.not) {
          vertical-align: top;
          font-weight: bold;
        }
        .not {
          display: inline-block;
          max-width: 76%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          vertical-align: top;
          cursor: pointer;
        }
        .tips-inidex {
          color: #456DEC;
        }
      }
    }
    .top-b {
      min-height: 35px;
      border: 2px solid #0853b6;
      display: flex;
      align-items: center;
      padding: 30px;
      position: relative;
      margin-top: 33px;
      span {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        background: #fff;
        padding: 0 20px;
        position: absolute;
        left: 20px;
        top: -14px;
        i {
          width: 3px;
          height: 3px;
          background: red;
          display: inline-block;
          vertical-align: middle;
          margin-top: -4px;
          margin-right: 6px;
        }
      }
    }
  }
  .center {
    background: #fff;
    padding: 30px 50px 30px;
    margin-top: 30px;
    display: flex;
    justify-content: center;
    box-shadow: 0px 1px 13px 0px rgba(0, 0, 0, 0.08);
    > div {
      width: 439px;
    }
    .center-p {
      display: flex;
      .left {
        width: 112px;
        height: 112px;
        background: linear-gradient(90deg, #0751b5 0%, #4e7bf5 100%);
        text-align: center;
        img {
          width: 72px;
          height: 72px;
          margin: 9px 0 0px;
        }
        div {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
        }
      }
      .right {
        background: rgba(57, 104, 225, 0.2);
        flex: 1;
        .title {
          font-size: 11px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #0853b6;
          text-align: center;
          padding-top: 16px;
        }
      }
    }
    .center-one {
      margin-right: 61px;
      .right {
        .day {
          text-align: center;
          margin-top: 12px;
          span:nth-child(1) {
            // width: 34px;
            padding: 0 6px;
            height: 40px;
            line-height: 40px;
            background: #ffffff;
            border-radius: 6px;
            display: inline-block;
            font-size: 36px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #d00d0d;
            margin-right: 6px;
          }
          span:nth-child(2) {
            font-size: 11px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #333333;
          }
        }
        .tips-icon {
          display: block;
          width: 32px;
          height: 33px;
          margin: 26px auto 10px;
        }
        .tips {
          text-align: center;
          font-size: 11px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #d73a3a;
          margin-top: 5px;
          &.default {
            font-size: 12px;
            color: #333333;
          }
        }
      }
    }
    .center-two {
      .right {
        .get-data {
          display: flex;
          margin-top: 10px;
          font-size: 11px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #333333;
          > div {
            flex: 1;
            text-align: center;
          }
          img {
            width: 38px;
            height: 38px;
          }
          .get-data-left {
            border-right: 1px solid rgba(8, 83, 182, 0.24);
          }
        }
      }
    }
  }
  .bottom {
    background: #fff;
    padding: 43px 50px 30px;
    margin-top: 29px;
    margin-bottom: 50px;
    .b-header {
      display: flex;
      align-items: center;
      height: 54px;
      background: linear-gradient(90deg, #0751b5 0%, #507cf7 100%);
      img {
        width: 25px;
        height: 25px;
        margin: 0 24px 0 19px;
      }
      span {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #fffefe;
      }
    }
    .b-date {
      // padding: 7px 0 11px;
      height: 88px;
      background: #f6f6f6;
      display: flex;
      margin: 30px 0 20px;
      text-align: center;
      ul {
        display: flex;
        height: 100%;
        li {
          flex: 1;
        }
      }
      .b-date-left {
        display: inline-block;
        width: 125px;
        padding: 14px 0 17px;
        border-right: 1px solid rgba(8, 83, 182, 0.25);
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        margin: 7px 0 11px;
      }
      .b-date-right-box{
        width: 100%;
        overflow-x: auto;
        display: flex;;
      }
      .b-date-right {
        display: inline-block;
        // width: 125px;
        height: 100%;
        flex: none;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #999999;
        vertical-align: top;
        display: flex;
        ul{
          width: 125px;
        }
        li {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          &.active {
            color: #333333;
            background: #b8d3ff;
            border-bottom: 4px solid #ff4e4e;
          }
          > div:nth-child(1).active {
            position: relative;
            &:after {
              content: '';
              width: 6px;
              height: 6px;
              background: #d00d0d;
              border-radius: 50%;
              position: absolute;
              right: -5px;
              top: 0px;
            }
          }
        }
      }
    }
    .b-time {
      // padding: 7px 0 11px;
      max-height: 350px;
      overflow-y: auto;
      padding: 50px 150px 260px;
      background: #f6f6f6;
      margin: 30px 0 20px;
      box-sizing: border-box;
      .el-timeline{
        position: relative;
      }
      .el-timeline-item__timestamp {
        color: #999;
      }
      .el-timeline-item__tail {
        border-left: 1px dashed #b5b5b5;
      }
      .date {
        position: absolute;
        left: -85px;
        top: -5px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        text-align: right;
      }
      .timestamp {
        color: #999;
        font-size: 14px;
        font-weight: bold;
      }
      .b-time-title {
        font-size: 16px;
        color: #333;
        font-weight: bold;
      }
      .b-time-des {
        font-size: 14px;
        color: #666;
      }
    }
  }
}
.container .bottom .b-time .date {
  left: -70px;
}
.el-timeline-item {
  padding-bottom: 40px !important;
}
</style>
